module.exports = __webpack_public_path__ + "img/50_36.66e79371.png";